<app-view-title mode="soft"
                Title="{{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer'}}: {{ booking?.RentalObject?.Alias ? booking?.RentalObject?.Title + ' - ' + booking?.RentalObject?.Alias : booking?.RentalObject?.Title }}">
</app-view-title>

<view-content [centered]="true"
              [fullscreen]="true">
  @if (!ignoreBTCheck && appSvc.Device.Bluetooth < 2) {
  <app-card>
    <app-btPermissionRequired></app-btPermissionRequired>
  </app-card>
  }
  @else if ((ignoreBTCheck || appSvc.Device.Bluetooth >= 2) && !ignoreLocationCheck && appSvc.Device.Location < 2) {
  <app-card>
    <app-locationPermissionRequired></app-locationPermissionRequired>
  </app-card>
  }
  @else {
    @if (!hasFailed) {
    <app-card>
      @if (!recentlyUnlocked) {
      <div class="spinner-container">
        <mat-progress-spinner diameter="75"
                              class="spinner"
                              mode="determinate"
                              [value]="count * (3 + 1.0 / 3.0)">
        </mat-progress-spinner>
        <h1 style="font-size: 24px">{{ 30 - count }}</h1>
      </div>
      }

      @if (isSearching) {
      <h2>{{ 'Intellitrailer.Rental.NokeLock.Searching' | translate : 'Searching for lock' }}...</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.ActiveLock' | translate : 'Gently press on the bottom part of the lock to activate it. ' }}</p>
      <div class="press-sensor-image"></div>
      }

      @if (isUnlocking) {
      <h2>{{ 'Intellitrailer.Rental.NokeLock.Unlocking' | translate : 'Unlocking' }}...</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.UnlockingInfo' | translate: 'This process normally takes between 5 and 10 seconds' }}</p>
      }

      @if (recentlyUnlocked) {
      <h2>{{ 'Intellitrailer.Rental.NokeLock.TitleLockNotOpen' | translate: 'Did the lock not open?' }}</h2>
      <div class="shake-lock-image"></div>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.Title2LockNotOpen' | translate: 'Check the shackle' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.txtLockNotOpen1' | translate: 'Sometimes the shackle gets stuck, if it does try this:'}}</p>
      <p>{{ 'Intellitrailer.Rental.NokeLock.txtLockNotOpen2' | translate: 'Shake the lock for 5-10 seconds.'}}</p>
      <p>{{ 'Intellitrailer.Rental.NokeLock.txtLockNotOpen3' | translate: 'Pull the lock downward at the same time you unlock it in the app.'}}</p>
      <button mat-raised-button (click)="continueUnlock()">{{ 'Intellitrailer.Rental.NokeLock.ButtonLockNotOpen' | translate: 'Continue' }}</button>
      }
    </app-card>
    }

    @if (hasFailed && failReason == null) {
    <app-card>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.NotFound' | translate : 'Lock was not found' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.NotFoundInfo' | translate : 'Make sure you are at the correct trailer.' }}</p>
      <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NokeLock.Retry' | translate : 'Retry' }}</button>
    </app-card>
    }

    @if (hasFailed && failReason == -1) {
    <app-card>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.headBluetoothError-1b' | translate : 'Could not find the lock' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.msgBluetoothError-1b' | translate : 'Verify that the light on the bottom of the lock lights upp when you press it. If this problem persists, please restart the app.' }}</p>
      <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NokeLock.Retry' | translate : 'Retry' }}</button>
    </app-card>
    }

    @if (hasFailed && failReason == 0) {
    <app-card>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.headBluetoothError0' | translate : 'Bluetooth access denied' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.msgBluetoothError0' | translate : 'Access to bluetooth is required to be able to unlock the lock. Please grant the permissions in you phone settings. Or re-install the app and it will ask you for the permission again.' }}</p>
      <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NokeLock.Retry' | translate : 'Retry' }}</button>
      @if (appSettings.meetsMinimumAppVersion(3.0)) {
      <button mat-raised-button color="accent" (click)="openSettings()">{{ 'Intellitrailer.Rental.NokeLock.cmdPermissions' | translate : 'Open settings' }}</button>
      }
    </app-card>
    }

    @if (hasFailed && failReason == 1) {
    <app-card>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.headBluetoothError1' | translate : 'Bluetooth is not enabled' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.msgBluetoothError1' | translate : 'Access to bluetooth is required to be able to unlock the lock. Please enable bluetooth and try again.' }}</p>
      <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NokeLock.Retry' | translate : 'Retry' }}</button>
    </app-card>
    }

    @if (hasFailed && failReason == 10) {
    <app-card>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.headLocationError0' | translate : 'Location access denied' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.msgLocationError0' | translate : 'Access to location is required to be able to unlock the lock. Please grant the permissions in you phone settings. Or re-install the app and it will ask you for the permission again.' }}</p>
      <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NokeLock.Retry' | translate : 'Retry' }}</button>
      @if (appSettings.meetsMinimumAppVersion(3.0)) {
      <button mat-raised-button color="accent" (click)="openSettings()">{{ 'Intellitrailer.Rental.NokeLock.cmdPermissions' | translate : 'Open settings' }}</button>
      }
    </app-card>
    }

    @if (hasFailed && failReason == 20) {
    <app-card>
      <h2>{{ 'Intellitrailer.Rental.NokeLock.headLocationError1' | translate : 'Location services is not enabled' }}</h2>
      <p>{{ 'Intellitrailer.Rental.NokeLock.msgLocationError1' | translate : 'Access to Location is required to be able to unlock the lock. Please enable Location and try again.' }}</p>
      <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Rental.NokeLock.Retry' | translate : 'Retry' }}</button>
    </app-card>
    }
  }
</view-content>

<view-actions>
  @if (!ignoreBTCheck && appSvc.Device.Bluetooth < 2) {
  <a (click)="skipBTCheck()">{{ 'Intellitrailer.Rental.NokeLock.cmdSkip' | translate : 'Skip' }}</a>
  }

  @if ((ignoreBTCheck || appSvc.Device.Bluetooth >= 2) && !ignoreLocationCheck && appSvc.Device.Location < 2) {
  <a (click)="skipLocationCheck()">{{ 'Intellitrailer.Rental.NokeLock.cmdSkip' | translate : 'Skip' }}</a>
  }

  @if (event != 'Active' && hasFailed) {
  <button mat-raised-button (click)="skip()">{{ 'Intellitrailer.Rental.NokeLock.cmdSkip' | translate : 'Skip' }}</button>
  }
</view-actions>

